import React, { forwardRef, useRef } from 'react';
import PropTypes from 'prop-types';
import { Form, Field } from 'react-final-form';
import { OnChange } from 'react-final-form-listeners';
import { FormFeedback } from './index';

export const Error = ({ name }) => (
  <Field
    name={name}
    subscription={{ touched: true, error: true }}
    render={({ meta: { touched, error } }) =>
      touched && error ? (
        <FormFeedback positive={false}>{error}</FormFeedback>
      ) : null
    }
  />
);

export const Condition = ({ when, is, children }) => (
  <Field name={when} subscription={{ value: true }}>
    {({ input: { value } }) => (value === is ? children : null)}
  </Field>
);

export const WhenFieldChanges = ({ field, becomes, includes, set, to }) => (
  <Field name={set} subscription={{}}>
    {(
      // No subscription. We only use Field to get to the change function
      { input: { onChange } }
    ) => (
      <OnChange name={field}>
        {value => {
          if (includes && includes.includes(value)) {
            onChange(to);
          } else if (value === becomes) {
            onChange(to);
          }
        }}
      </OnChange>
    )}
  </Field>
);

const BaseForm = forwardRef(
  ({ onSubmit, children, subscription, validate, initialValues }, ref) => {
    const formRef = useRef();

    return (
      <Form
        onSubmit={onSubmit}
        subscription={subscription}
        initialValues={initialValues}
        enableReinitialize
        validate={validate}
        render={({ handleSubmit }) => (
          <form
            onSubmit={handleSubmit}
            ref={formRef}
            className="activity-tracker__form"
          >
            {children}
          </form>
        )}
      />
    );
  }
);

export default BaseForm;
